import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Http } from '@angular/http';
import { AdminSound } from '../models/AdminSound';

@Injectable()
export class AdminSoundsService {
  constructor(private http: Http) {}

  all(regionId: number, user?: any): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.adminSounds.all.replace(
        '{regionId}',
        regionId.toString()
      );
    return this.http.get(url).map(res => {
      return res.json().map(j => new AdminSound(j, user));
    });
  }

  delete(regionId: number, filename: string): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.adminSounds.deleteRegionSound
        .replace('{regionId}', regionId.toString())
        .replace('{filename}', filename);
    return this.http.delete(url).map(res => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/admin-sounds.service.ts